


































import { Component, Prop, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { Case } from '@/modules/Case/interfaces/case'
import CaseFoldingCard from '@/modules/Newcase/components/CaseFoldingCard.vue'
import dollarFilter from '@/utils/dollarFilter'
import { dateToDisplay } from '@/utils/dateTime'
import AssetVehicleDialog from '@/modules/AccountAsset/scripts/asset-vehicle-dialog'
import AssetPropertyDialog from '@/modules/AccountAsset/scripts/asset-property-dialog'
import { formatPhoneNumber } from '@/utils/phoneNumberFormat'

@Component({
  components: {
    CaseFoldingCard
  }
})
export default class AccountInfo extends mixins(AssetVehicleDialog, AssetPropertyDialog) {
  @Prop({ type: Object as () => Case }) readonly caseInfo!: Case

  contactInfoCard = [
    { title: 'Primary Contact', content: '-' },
    {},
    { title: 'Phone', content: '-' },
    { title: 'Other Phone', content: '-' },
    { title: 'Billing Address Street', content: '-' },
    { title: 'Mailing Address Street', content: '-' },
    { title: 'Billing Address City', content: '-' },
    { title: 'Mailing Address City', content: '-' },
    { title: 'Billing Address State', content: '-' },
    { title: 'Mailing Address State', content: '-' },
    { title: 'Billing Address Zip/Postal Code', content: '-' },
    { title: 'Mailing Address Zip/Postal Code', content: '-' },
    { title: 'Billing Address Country', content: '-' },
    { title: 'Mailing Address Country', content: '-' }
  ]

  accountInfoCard = [
    { title: 'Client Name', content: '-' },
    { title: 'Book', content: '-' },
    { title: 'CSR', content: '-' },
    { title: 'Source', content: '-' },
    { title: 'Note', content: '-' },
    { title: 'Gender', content: '-' },
    { title: 'Salutation', content: '-' },
    { title: 'Birthday', content: '-' },
    { title: 'Legal Name', content: '-' }
  ]

  dateToDisplay = dateToDisplay
  dollarFilter = dollarFilter

  mounted () {
    this.onCaseUpdated(this.caseInfo)
  }

  getLegalName = (legalName : string | null) => {
    if (!legalName) return '-'
    const nameArr = legalName.split(' ').filter((name:string) => name && name !== 'null' && name !== 'undefined')

    if (nameArr.length === 0) {
      return '-'
    } else {
      return nameArr.join(' ')
    }
  }

  @Watch('caseInfo', { deep: true })
  onCaseUpdated (val: Case) {
    const { account } = val
    this.accountInfoCard[0].content = account.name
    this.accountInfoCard[1].content = account.book ? account.book.name : '-'
    this.accountInfoCard[2].content = account.csr ? account.csr.username : '-'
    this.accountInfoCard[3].content = account.source ? account.source.name : '-'
    this.accountInfoCard[4].content = account.notes || '-'
    this.accountInfoCard[5].content = '-'
    this.accountInfoCard[6].content = account.salutation || '-'
    this.accountInfoCard[7].content = '-'
    this.accountInfoCard[8].content = this.getLegalName(account.legalName)

    this.contactInfoCard[0].content = account.primaryContact ? account.primaryContact.name : '-'
    this.contactInfoCard[2].content = account.phone ? formatPhoneNumber(account.phone, account.countryCode, account.extensionNumber) : '-'
    this.contactInfoCard[3].content = account.otherPhone ? formatPhoneNumber(account.otherPhone, account.otherCountryCode, account.otherExtensionNumber) : '-'
    this.contactInfoCard[4].content = account.billingAddressStreet || '-'
    this.contactInfoCard[5].content = account.mailingAddressStreet || '-'
    this.contactInfoCard[6].content = account.billingAddressCity || '-'
    this.contactInfoCard[7].content = account.mailingAddressCity || '-'
    this.contactInfoCard[8].content = account.billingAddressState || '-'
    this.contactInfoCard[9].content = account.mailingAddressState || '-'
    this.contactInfoCard[10].content = account.billingAddressPostalCode || '-'
    this.contactInfoCard[11].content = account.mailingAddressPostalCode || '-'
    this.contactInfoCard[12].content = account.billingAddressCountry || '-'
    this.contactInfoCard[13].content = account.mailingAddressCountry || '-'
  }
}
